import type { ReactNode } from "react";
import {
  formatCacheHitRate,
  formatEstimatedCostUsd,
  formatTokenCount,
  type AiUsageSummary,
} from "./aiUsage";
import { MonitoringOverviewStrip } from "./MonitoringOverviewStrip";

export { StatCell } from "./MonitoringOverviewStrip";

type Props = { summary: AiUsageSummary; picker?: ReactNode };

export function AiOverviewStats({ summary, picker }: Props) {
  const stats = [
    {
      label: "Estimated spend",
      value: formatEstimatedCostUsd(summary.estimatedCostUsd ?? 0),
    },
    { label: "Tokens", value: formatTokenCount(summary.totalTokens) },
    { label: "Turns", value: summary.requestCount.toLocaleString("en-US") },
    {
      label: "Cache hit rate",
      value:
        summary.inputTokens === 0
          ? "0%"
          : formatCacheHitRate(summary.cacheReadTokens, summary.inputTokens),
    },
  ];

  return <MonitoringOverviewStrip stats={stats} picker={picker} />;
}
